<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <div class="orangehrm-background-container">
    <timesheet
      :loading="isLoading"
      :columns="timesheetColumns"
      :dates="timesheetDates"
      v-model:records="timesheetRecords"
      :employee="employee"
      :preset="preset"
      :timesheetSetting="timesheetSetting"
      :locationId="locationId?.id"
      :subtotal="timesheetSubtotal"
      :locationTitle="locationTitle"
      :upTimesheet="upTimesheet"
      :authUserRoleId="authUserRoleId"
      :authUserId="authUserId"
      :today="today"
    >
      <template #header-title>
        <oxd-grid-item>
          <oxd-input-field
            class="select-locations"
            v-model="locationId"
            type="select"
            required
            :label="$t('general.location')"
            :options="locations"
            :rules="rules.locations"
          />
        </oxd-grid-item>
      </template>
      <template #header-options>
        <timesheet-period
          v-model="date"
          :value="timesheetPeriod"
          @previous="onClickPrevious"
          @next="onClickNext"
        ></timesheet-period>
      </template>
      <template #footer-title>
        <oxd-text v-show="timesheetStatus" type="subtitle-2">
          tmp tmp tmp
        </oxd-text>
      </template>
      <template #footer-options>
        <oxd-button
          display-type="secondary"
          label="匯出更表"
          @click="onClickExport"
        />
        <oxd-button
          display-type="secondary"
          label="設定預設時間"
          @click="onClickPreset"
        />
      </template>
    </timesheet>
  </div>
</template>

<script>
import {toRefs, ref} from 'vue';
import {APIService} from '@/core/util/services/api.service';
import Timesheet from '@/orangehrmTimePlugin/components/Timesheet.vue';
import useTimesheet from '@/orangehrmTimePlugin/util/composable/useTimesheet';
import TimesheetPeriod from '@/orangehrmTimePlugin/components/TimesheetPeriod.vue';
import TimesheetActions from '@/orangehrmTimePlugin/components/TimesheetActions.vue';
import {navigate} from '@ohrm/core/util/helper/navigation';

export default {
  components: {
    timesheet: Timesheet,
    'timesheet-period': TimesheetPeriod,
  },

  props: {
    startDate: {
      type: String,
      required: false,
      default: null,
    },
    locations: {
      type: Array,
      default: () => [],
    },
    authUserId: {
      type: Number,
      required: true,
    },
    authUserRoleId: {
      type: Number,
      required: true,
    },
    today: {
      type: String,
      required: true,
      default: null,
    },
  },

  setup(props) {
    const localLocationId = ref(props.locations[0] || null);
    const localLocationTitle = ref(props.locations[0]?.label || null);

    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/time/timesheets',
    );

    const {
      state,
      onClickEdit,
      onClickNext,
      onClickSubmit,
      onClickPrevious,
      timesheetPeriod,
      canEditTimesheet,
      canSubmitTimesheet,
      canCreateTimesheet,
      showCreateTimesheet,
      onClickCreateTimesheet,
      upTimesheet,
    } = useTimesheet(http, props.startDate, props.locations[0]?.id);

    return {
      onClickEdit,
      onClickNext,
      onClickSubmit,
      onClickPrevious,
      ...toRefs(state),
      timesheetPeriod,
      canEditTimesheet,
      canSubmitTimesheet,
      canCreateTimesheet,
      showCreateTimesheet,
      onClickCreateTimesheet,
      locationId: localLocationId,
      locationTitle: localLocationTitle,
      upTimesheet,
    };
  },
  data() {
    return {
      statuses: [
        {id: 1, label: this.$t('time.submitted'), name: 'Submitted'},
        {id: 2, label: this.$t('leave.rejected'), name: 'Rejected'},
        {id: 3, label: this.$t('time.not_submitted'), name: 'Not Submitted'},
        {id: 4, label: this.$t('time.approved'), name: 'Approved'},
      ],
      rules: {
        locations: [
          (v) => {
            this.locationTitle = this.locationId.label;
            this.upTimesheet(this.locationId.id);
            return true;
          },
        ],
      },
    };
  },
  computed: {
    myTimesheetStatus() {
      return (
        this.statuses.find((item) => item.name === this.timesheetStatus)
          ?.label || null
      );
    },
  },
  methods: {
    onClickPreset() {
      if (this.locationId) {
        navigate(`/time/editTimesheetPreset/${this.locationId.id}`);
      }
    },
    onClickExport() {
      window.open(
        `${window.appGlobal.baseUrl}/../api/LocationTimesheetAPI.php?select_date=${this.date}&locationId=${this.locationId.id}&type=pdf`,
        '_blank',
      );
      // window.open(``);
    },
  },
};
</script>
<style type="text/css">
.select-locations {
  min-width: 180px;
}
</style>
